


import React from 'react'
import './gallery.css'
import HeaderAbout from '../../component/headerabout/HeaderAbout'
import headerimage from "../../images/header_bg_3.jpg";

function Gallery() {
  const galleryth = 15;
  const images =  []

  for(let i = 1; i <= galleryth; i++){
    images.push(require(`../../images/gallery${i}.jpg`))
  }
  console.log(images);

  return (
    <>
      <HeaderAbout title="our Gallery" image={headerimage}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Saepe nihil quibusdam quaerat repudiandae, veritatis quidem.
      </HeaderAbout>
      <section className='gallery'>
        <div className="container gallery__container">
          {
            images.map((image, index) => {
              return <article key={index}>
                  <img src={image} alt={`gallery image ${index + 1}`} />
              </article>
            })
          }
        </div>
      </section>

    </>
  )
}

export default Gallery